let holds = 0

/** True while `holdScrollAnchor` is scrolling the window, so scroll-direction UI can ignore it. */
export const isHoldingScrollAnchor = () => holds > 0

/** The element whose vertical center sits closest to the viewport's. */
export function centermostElement(els: Iterable<Element>): Element | undefined {
  const mid = window.innerHeight / 2
  let best: Element | undefined
  let bestDist = Infinity
  for (const el of els) {
    const r = el.getBoundingClientRect()
    const dist = Math.abs(r.top + r.height / 2 - mid)
    if (dist < bestDist) {
      best = el
      bestDist = dist
    }
  }
  return best
}

/**
 * Pins `anchor` to its current spot on screen for `ms` while the layout around
 * it animates, scrolling the window each frame to cancel its drift. CSS
 * `overflow-anchor` can't do this: WebKit lacks it, and it anchors to the top
 * of the viewport rather than the card being read. Any touch or wheel lets go.
 */
export function holdScrollAnchor(anchor: Element, ms: number) {
  const top = anchor.getBoundingClientRect().top
  const end = performance.now() + ms
  let released = false
  const release = () => { released = true }
  window.addEventListener('touchstart', release, { passive: true, once: true })
  window.addEventListener('wheel', release, { passive: true, once: true })
  holds++

  const step = () => {
    if (!released && anchor.isConnected) {
      const drift = anchor.getBoundingClientRect().top - top
      if (Math.abs(drift) >= 0.5) window.scrollTo({ top: window.scrollY + drift, behavior: 'instant' })
    }
    if (!released && anchor.isConnected && performance.now() < end) {
      requestAnimationFrame(step)
      return
    }
    window.removeEventListener('touchstart', release)
    window.removeEventListener('wheel', release)
    // The last correction's scroll event is still queued; let it land while held.
    requestAnimationFrame(() => { holds-- })
  }
  requestAnimationFrame(step)
}
